var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: { form: _vm.form, rules: _vm.rules, "label-width": "120px" },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("goodsBrand.table.name"),
                prop: "brandName",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.brandName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "brandName", $$v)
                  },
                  expression: "form.brandName",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c("BjFormItemCode", {
            attrs: { label: _vm.$t("goodsBrand.table.code"), prop: "code" },
            model: {
              value: _vm.form.code,
              callback: function ($$v) {
                _vm.$set(_vm.form, "code", $$v)
              },
              expression: "form.code",
            },
          }),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("goodsBrand.table.Manufacturer"),
                prop: "manufacturer",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.manufacturer,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "manufacturer", $$v)
                  },
                  expression: "form.manufacturer",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("table.remarkText"), prop: "remark" } },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "remark", $$v)
                  },
                  expression: "form.remark",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("goodsBrand.table.LOGO"), prop: "logo" } },
            [
              _c(
                "BjUpload",
                {
                  ref: "upload",
                  staticClass: "avatar-uploader",
                  attrs: {
                    "auto-upload": "",
                    accept: "image/png,image/jpeg,image/gif",
                    "accept-list": ["image/jpeg", "image/png", "image/gif"],
                    "limit-size": 50,
                    "out-size-text": _vm.$t("goodsBrand.page.uploadedSize"),
                  },
                  on: { afterUpload: _vm.afterUpload },
                },
                [
                  _c(
                    "template",
                    { slot: "default" },
                    [
                      _vm.form.logo
                        ? _c("BjKeyImage", {
                            staticClass: "avatar",
                            attrs: { url: _vm.form.logo },
                          })
                        : _c("i", {
                            staticClass: "el-icon-plus avatar-uploader-icon",
                          }),
                    ],
                    1
                  ),
                  _c("template", { slot: "tip" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("goodsBrand.page.uploadedTip")) + " "
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }